var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMesh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 24,
    viewBox: "0 0 84 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9443 0.631579H25.7517V23.3684H19.6124V11.2854L14.6346 18.7561H11.117L6.13925 11.2529V23.3684H0V0.631579H5.8074L12.8758 11.2854L19.9443 0.631579ZM30.9233 1.44658C32.8893 0.493151 35.1775 0 37.4658 0C43.5571 0 49.6807 3.64931 49.6807 12.3288C49.6807 20.5479 43.5249 24 37.3369 24C35.1131 24 32.8893 23.5068 30.9233 22.5534V16.6356C32.3414 18.0164 34.404 18.5753 36.4345 18.5753C39.7541 18.5753 42.8159 17.8521 43.6538 14.5315H34.3074V9.43562H43.5571C42.6225 6.14795 39.8185 5.45753 36.5634 5.42466C34.6619 5.42466 32.4058 5.95069 30.9233 7.2V1.44658ZM84 23.4801H53.4795V0.743227H59.6503V18.1207H65.6544V0.743227H71.8252V18.1207H77.8292V0.743227H84V23.4801Z",
    fill: "#2B3858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesh);
export default __webpack_public_path__ + "static/media/mesh.c9706facb84db943750780ba1591789f.svg";
export { ForwardRef as ReactComponent };